// Test IDs for the Illinois Broker Prep storefront.
export const STORE = {
  // Navigation
  nav: "site-nav",
  navMobileMenuButton: "nav-mobile-menu-button",
  navHomeLink: "nav-home-link",
  navProductLink: "nav-product-link",
  navPreviewLink: "nav-preview-link",
  navFaqLink: "nav-faq-link",
  navCoverageLink: "nav-coverage-link",
  navContactLink: "nav-contact-link",
  navPrimaryCta: "nav-primary-cta",
  navBrand: "nav-brand-link",

  // Footer
  footer: "site-footer",
  footerDisclaimer: "footer-independent-disclaimer",
  footerDisclaimerLink: "footer-disclaimer-link",
  footerRefundLink: "footer-refund-policy-link",
  footerPrivacyLink: "footer-privacy-policy-link",
  footerTermsLink: "footer-terms-of-service-link",
  footerContactLink: "footer-contact-link",

  // Home
  hero: "home-hero",
  heroPrimaryCta: "home-hero-primary-cta",
  heroSecondaryCta: "home-hero-secondary-cta",
  heroTrustChip1: "home-hero-trust-chip-1",
  homeFinalCta: "home-final-cta",
  homeFaqMoreLink: "home-faq-more-link",
  homePreviewLink: "home-preview-link",

  // Product
  productPage: "product-page",
  productBuyButton: "product-buy-button",
  productPreviewButton: "product-preview-button",
  productPrice: "product-price",

  // Free Preview
  previewPage: "free-preview-page",
  mockupCover: "preview-mockup-cover",
  mockupToc: "preview-mockup-toc",
  mockupQuestion: "preview-mockup-il-question",
  mockupExplanation: "preview-mockup-explanation",
  mockupScore: "preview-mockup-score-tracker",
  previewBuyCta: "free-preview-buy-cta",

  // FAQ
  faqPage: "faq-page",
  faqAccordion: "faq-accordion",

  // Refund / Disclaimer
  refundPage: "refund-policy-page",
  disclaimerPage: "disclaimer-page",
  disclaimerAlert: "disclaimer-key-alert",
  privacyPage: "privacy-policy-page",
  termsPage: "terms-of-service-page",
  coveragePage: "coverage-page",

  // Contact
  contactPage: "contact-page",
  contactForm: "contact-form",
  contactName: "contact-form-name-input",
  contactEmail: "contact-form-email-input",
  contactMessage: "contact-form-message-textarea",
  contactSubmit: "contact-form-submit-button",
  contactSuccess: "contact-form-success-message",
  contactError: "contact-form-error-message",

  // Settings (admin)
  settingsPage: "settings-page",
  shopifyUrlInput: "settings-shopify-url-input",
  shopifyUrlSave: "settings-shopify-url-save-button",
  shopifyUrlStatus: "settings-shopify-url-status",

  // Admin auth toolbar + contact inbox
  adminNavSettings: "admin-nav-settings-link",
  adminNavInbox: "admin-nav-inbox-link",
  adminNavQuestions: "admin-nav-questions-link",
  adminNavAccessCodes: "admin-nav-access-codes-link",
  adminNavWebhooks: "admin-nav-webhooks-link",
  adminNavTutorUsage: "admin-nav-tutor-usage-link",
  inboxPage: "admin-inbox-page",
  inboxEmpty: "admin-inbox-empty",
  inboxMessageCard: "admin-inbox-message-card",
  inboxDeleteButton: "admin-inbox-delete-button",

  // Diagnostic
  navDiagnosticLink: "nav-diagnostic-link",
  diagnosticPage: "diagnostic-page",
  diagnosticProgress: "diagnostic-progress",
  diagnosticChoice: "diagnostic-choice",
  diagnosticBack: "diagnostic-back-button",
  diagnosticNext: "diagnostic-next-button",
  diagnosticResultsPage: "diagnostic-results-page",
  diagnosticEmailCard: "diagnostic-email-card",
  diagnosticEmailInput: "diagnostic-email-input",
  diagnosticEmailSubmit: "diagnostic-email-submit",
  diagnosticEmailStatus: "diagnostic-email-status",
  diagnosticReviewItem: "diagnostic-review-item",
  diagnosticCheckoutCta: "diagnostic-checkout-cta",
  diagnosticPlanPreview: "diagnostic-plan-preview",
  diagnosticPlanPreviewDay: "diagnostic-plan-preview-day",
  diagnosticWeakChecklist: "diagnostic-weak-checklist",
  diagnosticPrimaryCta: "diagnostic-primary-cta",
};

// Study accounts + admin question bank
export const STUDY = {
  navStudyLink: "nav-study-link",
  loginPage: "study-login-page",
  loginEmail: "study-login-email",
  loginCode: "study-login-code",
  loginSubmit: "study-login-submit",
  loginResend: "study-login-resend",
  logout: "study-logout",
  dashboard: "study-dashboard",
  navLearn: "study-nav-learn",
  learnPage: "study-learn-page",
  lessonPage: "study-lesson-page",
  lessonCheckpoint: "study-lesson-checkpoint",
  lessonComplete: "study-lesson-complete",
  navQuestionBank: "study-nav-question-bank",
  navExamMode: "study-nav-exam-mode",
  practicePage: "study-practice-page",
  questionBankPage: "study-question-bank-page",
  questionBankTopic: "study-question-bank-topic",
  questionBankStart: "study-question-bank-start",
  missedPage: "study-missed-page",
  bookmarksPage: "study-bookmarks-page",
  miniExamsPage: "study-mini-exams-page",
  modeButton: "study-mode-button",
  trapDrillButton: "study-trap-drill-button",
  questionCard: "study-question-card",
  choice: "study-choice",
  submit: "study-submit",
  next: "study-next",
  bookmark: "study-bookmark",
  explanation: "study-explanation",
  questionReport: "study-question-report",
  emptyState: "study-empty",
  adminQuestionsPage: "admin-questions-page",
  adminQuestionRow: "admin-question-row",
  adminImport: "admin-import-json",
  adminAccessCodeRow: "admin-access-code-row",
  adminAccessCodesPage: "admin-access-codes-page",
  adminAccessCodeCreate: "admin-access-code-create",
  adminAccessCodeBatch: "admin-access-code-batch",
  adminAccessCodeSearch: "admin-access-code-search",
  // Timed Review Sprints
  sprintCard: "sprint-card",
  sprintStart: "sprint-start",
  sprintRunner: "sprint-runner",
  sprintTimer: "sprint-timer",
  sprintChoice: "sprint-choice",
  sprintPrev: "sprint-prev",
  sprintNext: "sprint-next",
  sprintSubmit: "sprint-submit",
  sprintConfirmSubmit: "sprint-confirm-submit",
  sprintResults: "sprint-results",
  sprintReviewToggle: "sprint-review-toggle",
  sprintResumeBanner: "sprint-resume-banner",
  // Question Coach (grounded, capped)
  tutorPanel: "study-tutor-panel",
  tutorPrompt: "study-tutor-prompt",
  tutorInput: "study-tutor-input",
  tutorSend: "study-tutor-send",
  tutorReply: "study-tutor-reply",
  tutorQuota: "study-tutor-quota",
  // Exam-readiness ring
  readinessRing: "study-readiness-ring",
  sectionReadiness: "study-section-readiness",
  examWeekPage: "study-exam-week-page",
  feedbackPage: "study-feedback-page",
  feedbackSubmit: "study-feedback-submit",
  // Structured study plans
  navStudyPlan: "study-nav-plan",
  planPage: "study-plan-page",
  planCreate: "study-plan-create",
  planTypeOption: "study-plan-type",
  planExamDate: "study-plan-exam-date",
  planDay: "study-plan-day",
  planDayToggle: "study-plan-day-toggle",
  planTodayCard: "study-plan-today",
  planChange: "study-plan-change",
  // Admin: Shopify webhook deliveries
  adminWebhookDeliveriesPage: "admin-webhook-deliveries-page",
  adminWebhookDeliveryRow: "admin-webhook-delivery-row",
  adminWebhookResend: "admin-webhook-resend",
  adminRevenueSummary: "admin-revenue-summary",
  adminFulfillmentStatus: "admin-fulfillment-status",
  // Admin: AI tutor usage
  adminTutorUsagePage: "admin-tutor-usage-page",
  adminTutorUsageRow: "admin-tutor-usage-row",
  // Flashcards / vocabulary mode (AI-generated study aid)
  navFlashcards: "study-nav-flashcards",
  flashcardsPage: "study-flashcards-page",
  flashcardsGenerate: "study-flashcards-generate",
  flashcard: "study-flashcard",
  flashcardFlip: "study-flashcard-flip",
  flashcardKnown: "study-flashcard-known",
  flashcardReview: "study-flashcard-review",
  flashcardsAiNote: "study-flashcards-ai-note",
  flashcardsEmpty: "study-flashcards-empty",
  // Admin: flashcards management
  adminNavFlashcards: "admin-nav-flashcards-link",
  adminFlashcardsPage: "admin-flashcards-page",
  adminFlashcardRow: "admin-flashcard-row",
  adminFlashcardEdit: "admin-flashcard-edit",
  adminFlashcardSave: "admin-flashcard-save",
  adminFlashcardDelete: "admin-flashcard-delete",
  adminQualityPage: "admin-quality-page",
  adminQuestionReportRow: "admin-question-report-row",
  adminFeedbackRow: "admin-feedback-row",
};
